module.exports = __webpack_public_path__ + "static/img/1.4b83f9b2.png";